export default __webpack_public_path__ + "static/media/articleexpertdashboard.896e2eda.svg";